import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, Grid, Icon, IconButton, LinearProgress, TextField, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import _ from 'lodash';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { DataGrid, GridColumns, GridValueGetterParams } from "@mui/x-data-grid";
import { individualSchema } from "../IndividualValidation";
import { SalaryDtos } from "../../../../Component/Model/Dto/Salaries";
import { Individual } from "../../../../Component/Model/Dto/Individual";
import { IndividualService } from "../../../../Component/Api/Individual/IndividualService";
import { PeopleDtos } from "../../../../Component/Model/Dto/People";
import { PeopleService } from "../../../../Component/Api/People/peopleService";
import { defaultObject } from "../../../../Helpers/typescriptHelper";
import AppAccordion from "../../../../Component/Common/Components/Accordion/AppAccordion";
import { DateFormatter } from "../../../../Component/Model/helpers";
import { decimalFormatter } from "../../../../Helpers/DecimalFormatter";
import { MDButton } from "../../../../Component/Common/Components/MDButton";
import { CustomDialogTitle } from "../../Custom/CustomDialogTitle";
import { SkeletonLoading } from "../../../../Component/Common/SkeletonLoading/SkeletonLoading";
import AppTextInput from "../../../../Component/Common/Components/FormValidationInputs/AppTextInput";
import AppSelectList from "../../../../Component/Common/Components/FormValidationInputs/AppSelectList";
import { genderList, provinceList, raceList } from "../../../../Component/Common/Constants/Lists/DropdownListOptions";
import { AppDatepicker } from "../../../../Component/Common/Components/FormValidationInputs/AppDatepicker";
import AppCheckbox from "../../../../Component/Common/Components/FormValidationInputs/AppCheckbox";


const useStyles = makeStyles({
  root: {
    "& .row--0": {
      backgroundColor: "#bdd7ee" //actual
    },
    "& .row--1": {
      backgroundColor: "white" //input
    },
    "& .row--2": {
      backgroundColor: "#e7e6e6" //percentage
    },
    "& .row--3": {
      backgroundColor: "#d6dce4" //headcountValue
    }
  }
});

interface IProps {
  id: number;
  scorecardId: string;
  showIndividualModal: boolean;
  closeIndividualModal: () => void;
}

const availableOccupationLevelTypes: number[] = [2, 1, 4, 5, 6, 7, 8, 9, 10];

export const IndividualSalaryModal_Old = (props: IProps) => {
  const classes = useStyles();
  const { control, reset, handleSubmit, formState: { isSubmitting }, setValue } = useForm({
    mode: 'all',
    resolver: yupResolver(individualSchema)
  });
  const [personId, setPersonId] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [addSalariesDialogOpen, setAddSalariesDialogOpen] = useState<boolean>(false);
  const [yearToAdd, setYearToAdd] = useState<number>();
  const [salaryData, setSalaryData] = useState<SalaryDtos.ISalariesPerYearResponse[]>([]);

  const getEmployeeData = async (id: number) => {
    if (id === undefined || id === 0) return;
    try {
      const request: Individual.GetRequest = {
        id: id,
        scorecardId: props.scorecardId,
        LinkedType: undefined,
        InterventionId: undefined,
        filterVAStartDate: undefined,
        filterVAEndDate: undefined
      }
      setIsLoading(true);
      const result = await IndividualService.GetIndividualByID(request);
      reset(result.data as Individual.IndividualDto);

      const checkPersonRequest: PeopleDtos.CheckPerson = {
        identificationNumber: result.data.identificationNumber as string,
        employeeCode: result.data.employeeCode as string
      }
      const checkPersonResult = await PeopleService.GetPersonBeforeCreate(checkPersonRequest);
      if (checkPersonResult.data !== null) {
        setPersonId(checkPersonResult.data.id);
        GetSalaries(checkPersonResult.data.id);
      }
      else {
        setPersonId(0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  const GetSalaries = async (personId: number) => {
    try {
      setIsLoading(true);
      const result = await PeopleService.GetPeopleSalariesForYears_Old(personId);
      setSalaryData(result.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  const hasSalaryData = (): boolean => {
    return salaryData && salaryData.length > 0;
  }

  const handleDataSubmit = async (data: FieldValues) => {
    try {
      const finalData = data as Individual.IndividualUpdateDto;
      finalData.SampledIndividualViewModel = null;
      const result = await IndividualService.SaveIndividual(finalData);
      toast.success(`Employee updated successfully`);
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getEmployeeData(props.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showIndividualModal, props.id])

  const handleDeleteYear = async (year: number) => {
    try {
      setIsLoading(true);
      await PeopleService.DeletePeopleSalariesForYear(personId, year)
        .then(async (result) => {
          if (result.status >= 200 && result.status <= 299) {
            await GetSalaries(personId);
          }
        });
    } catch (error: any) {
      toast.error(error.response.data);
    } finally {
      setIsLoading(false);
    }
  }

  const processSalaryUpdate = async (newRow: SalaryDtos.ISalaryResponse, oldRow: SalaryDtos.ISalaryResponse) => {
    if (_.isEqual(newRow, oldRow))
      return newRow;

    try {
      let data = salaryData;
      let year = new Date(newRow.salaryDate).getFullYear();
      let idxBlock = data.findIndex(x => x.year === year);
      let block = data[idxBlock];
      if (!block)
        return oldRow;

      let idxSalary = _.findIndex(block.salaries, x => x.salaryDate === newRow.salaryDate);
      let salaries = block.salaries
      let salary = { ...salaries[idxSalary], ctc: newRow.ctc, variable: newRow.variable, fixed: newRow.fixed } || defaultObject;
      salaries = salaries.filter(x => x.salaryDate !== newRow.salaryDate);
      salaries.push(salary);
      salaries = _.sortBy(salaries, x => new Date(x.salaryDate));
      block.salaries = salaries;
      data.splice(idxBlock, 1, block);
      setSalaryData(data);

      return newRow;

    } catch (error: any) {
      toast.error(error.response.data);
      return oldRow;
    } finally { }
  }

  const addYear = async () => {
    try {
      setIsLoading(true);
      if (salaryData.findIndex(x => x.year === yearToAdd) > -1) {
        toast.warning(`Year ${yearToAdd} rows already exists.`);
        return;
      }

      await PeopleService.AddPeopleSalariesForYear_Old(personId, yearToAdd!)
        .then(async (result) => {
          setSalaryData([...salaryData, result.data]);
        });
    } catch (error: any) {
      toast.error(error.response.data);
    } finally {
      setIsLoading(false);
      setAddSalariesDialogOpen(false);
    }
  }

  const handleYearChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setYearToAdd(+event.target.value);
  };

  const saveSalariesForYear = async (year: number) => {
    const data: SalaryDtos.ISalariesPerYearResponse | undefined = _.find(salaryData, x => x.year === year);

    if (!data)
      return;

    try {
      setIsLoading(true);
      await PeopleService.SavePeopleSalariesForYear_Old(personId, data);
      toast.success('Salaries for year succesfully saved');
    } catch (error: any) {
      toast.error(error.response.data);
    } finally {
      setIsLoading(false);
    }
  }

  const renderSalaries = () => {
    return hasSalaryData() ? (salaryData.sort((a, b) => b.year - a.year).map((blockItem: SalaryDtos.ISalariesPerYearResponse, index) => {
      return (
        <AppAccordion
          expandOnDefault={true}
          label={blockItem.year.toString()}
          summaryActions={renderDeleteYear(blockItem.year)}
          key={`acc-year-${blockItem.year}`}>
          {
            renderSalariesForYear(blockItem.year, blockItem.salaries)
          }
        </AppAccordion>
      )
    })) : (<></>);
  }

  const getTotalSalaries = (arr: SalaryDtos.ISalaryResponse[]) => {
    const result = arr.reduce((accumulator, obj) => {
      return accumulator + obj.ctc;
    }, 0);
  }

  const colMonthWidth: number = 200;
  const colSalariesWidth: number = 150;
  const columns: GridColumns = [
    {
      field: 'salaryDate', headerName: 'Month', editable: false, width: colMonthWidth, type: 'string', sortable: false,
      valueGetter: (params: GridValueGetterParams) => {
        return DateFormatter((params.row as SalaryDtos.ISalaryResponse).salaryDate.toString(), 'MMMM');
      }
    },
    {
      field: 'ctc', headerName: 'CTC', editable: true, width: colSalariesWidth, type: 'number', sortable: false,
      valueFormatter: ({ value }) => decimalFormatter(value)
    },
    {
      field: 'fixed', headerName: 'FIXED', editable: true, width: colSalariesWidth, type: 'number', sortable: false,
      valueFormatter: ({ value }) => decimalFormatter(value)
    },
    {
      field: 'variable', headerName: 'VARIABLE', editable: true, width: colSalariesWidth, type: 'number', sortable: false,
      valueFormatter: ({ value }) => decimalFormatter(value)
    },

  ];
  const aggregateColumns: GridColumns = [
    {
      field: 'salaryDate', headerName: 'Month', editable: false, width: colMonthWidth, type: 'string', sortable: false,
    },
    {
      field: 'ctc', headerName: 'CTC', editable: false, width: colSalariesWidth, type: 'number', sortable: false,
      valueFormatter: ({ value }) => decimalFormatter(value)
    },
    {
      field: 'fixed', headerName: 'FIXED', editable: false, width: colSalariesWidth, type: 'number', sortable: false,
      valueFormatter: ({ value }) => decimalFormatter(value)
    },
    {
      field: 'variable', headerName: 'VARIABLE', editable: false, width: colSalariesWidth, type: 'number', sortable: false,
      valueFormatter: ({ value }) => decimalFormatter(value)
    },

  ];

  const annualizedColumns: GridColumns = [
    {
      field: 'salaryDate', headerName: 'Month', editable: false, width: colMonthWidth, type: 'string', sortable: false,
    },
    {
      field: 'ctc', headerName: 'CTC', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    },
    {
      field: 'fixed', headerName: 'FIXED', editable: false, width: colSalariesWidth, type: 'number', sortable: false,
      valueFormatter: ({ value }) => decimalFormatter(value)
    },
    {
      field: 'variable', headerName: 'VARIABLE', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    },

  ];



  const renderSalariesForYear = (year: number, salaries: SalaryDtos.ISalaryResponse[]) => {
    let totalsCtc = salaries.reduce((sum, current) => sum + current.ctc, 0);
    let totalsFixed = salaries.reduce((sum, current) => sum + current.fixed, 0);
    let totalsVariable = salaries.reduce((sum, current) => sum + current.variable, 0);
    let summedCTCValue = 0;
    let summedFixedValue = 0;
    let summedVariableValue = 0;
    let ctcCount = 0;
    let variableCount = 0;
    let fixedCount = 0;
    salaries.forEach(function (salary) {
      summedFixedValue += salary.fixed;
      summedVariableValue += salary.variable;
      summedCTCValue += salary.ctc;
      fixedCount += salary.fixed > 0 ? 1 : 0;
      variableCount += salary.variable > 0 ? 1 : 0;
      ctcCount += salary.ctc > 0 ? 1 : 0;

    });

    const annualizedCtc = null;
    const annualizedFixed = fixedCount > 0 ? (summedFixedValue / fixedCount) * 12 : 0;
    const annualizedVariable = null;

    return salaries && salaries.length > 0 ?
      (<div>
        <Grid container mb={1}>
          <Grid item xs={12}>
            <DataGrid
              key={`salaries-grd-${year}`}
              headerHeight={70}
              className={classes.root}
              disableSelectionOnClick
              autoHeight
              hideFooter
              disableColumnFilter
              disableColumnMenu
              disableColumnSelector
              rowHeight={25}
              rows={salaries}
              columns={columns}
              editMode="row"
              isCellEditable={(params) => (true)}
              experimentalFeatures={{ newEditingApi: true }}
              processRowUpdate={processSalaryUpdate}
              components={{
                LoadingOverlay: LinearProgress,
              }}
              loading={isLoading}
            />
            <DataGrid
              key={`salaries-totals-grd-${year}`}
              headerHeight={0}
              className={classes.root}
              disableSelectionOnClick
              autoHeight
              hideFooter
              disableColumnFilter
              disableColumnMenu
              disableColumnSelector
              rowHeight={30}
              rows={[
                { id: 1, salaryDate: 'TOTAL', ctc: totalsCtc, fixed: totalsFixed, variable: totalsVariable }
              ]}
              columns={aggregateColumns}
              isCellEditable={(params) => (true)}
              components={{
                LoadingOverlay: LinearProgress,
              }}
              loading={isLoading}
            />
            <DataGrid
              key={`salaries-totals-grd-${year}`}
              headerHeight={0}
              className={classes.root}
              disableSelectionOnClick
              autoHeight
              hideFooter
              disableColumnFilter
              disableColumnMenu
              disableColumnSelector
              rowHeight={30}
              rows={[
                { id: 1, salaryDate: 'Annualized', ctc: '', fixed: annualizedFixed, variable: '' }
              ]}
              columns={annualizedColumns}
              isCellEditable={(params) => (true)}
              components={{
                LoadingOverlay: LinearProgress,
              }}
              loading={isLoading}
            />
          </Grid>
        </Grid>
        <MDButton color="primary" onClick={() => {
          saveSalariesForYear(year);
        }}> {'Save ' + year + " Salaries"}
        </MDButton>
      </div>)
      :
      (<div>no salary rows for year</div>);
  }

  const renderDeleteYear = (year: number) => {
    return (
      <Tooltip title="Delete salary data">
        <IconButton
          aria-label="close" size="small"
          style={{ float: 'right', color: 'inherit' }}
          onClick={() => handleDeleteYear(year)}>
          <Icon sx={{ color: '#fff' }}>delete</Icon>
        </IconButton>
      </Tooltip>)
  }

  return (
    <Dialog disableEnforceFocus open={props.showIndividualModal} onClose={() => { props.closeIndividualModal() }} aria-labelledby="form-dialog-title" maxWidth='lg'>
      <CustomDialogTitle id="individual-dialog-title" onClose={() => props.closeIndividualModal()}>
        {'View/Edit Employee & Salary Details'}
      </CustomDialogTitle>
      <DialogContent>
        {isLoading && <SkeletonLoading formLoading FieldAmount={6} width={350} />}
        {!isLoading &&
          <Box>
            <AppAccordion expandOnDefault={true} label={'Employee Data'}>
              <form id='IndividualForm' onSubmit={handleSubmit(handleDataSubmit)}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} mt={1}>
                    <AppTextInput control={control} name="identificationNumber" label="ID Number" />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppTextInput control={control} name="employeeCode" label="Employee Code" />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppTextInput control={control} name="firstName" label="Name" />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppTextInput control={control} name="lastName" label="Surname" />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppSelectList control={control} name="gender" label="Gender" items={genderList} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppSelectList control={control} name="raceId" label="Race" items={raceList} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppSelectList control={control} name="province" label="Province" items={provinceList} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppDatepicker control={control} name="dateOfBirth" label="Date Of Birth" inputFormat='yyyy/MM/dd' />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppCheckbox control={control} name='disabled' label='Disabled' disabled={false} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppCheckbox control={control} name='isYes' label='Y.E.S. Employee' disabled={false} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AppCheckbox control={control} name='isYesAbsorbed' label='Y.E.S. Absorbed' disabled={false} />
                  </Grid>
                </Grid>
              </form>
            </AppAccordion>

            <Box mt={1} mb={1}>
              <Typography variant='h6' component='div' mb={1}>Salaries per year</Typography>
              <MDButton variant="contained" color="secondary" onClick={() => {
                setAddSalariesDialogOpen(true);
              }}>
                Add Year
              </MDButton>
            </Box>

            <Box>
              <Dialog open={addSalariesDialogOpen} maxWidth='sm'>
                <CustomDialogTitle id="customized-dialog-title" onClose={() => setAddSalariesDialogOpen(false)}>
                  Add salaries for year
                </CustomDialogTitle>
                <DialogContent >
                  <Box mt={1}>
                    <TextField
                      id="txt-yearToAdd-withValue"
                      label="Year"
                      sx={{ width: '300px' }}
                      onChange={handleYearChange}
                      value={yearToAdd}
                    />
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Box>
                    <Button onClick={() => {
                      addYear();
                    }}>Add</Button>
                  </Box>
                </DialogActions>
              </Dialog>

              {renderSalaries()}

            </Box>
          </Box >}
      </DialogContent>
      <DialogActions>
        <LoadingButton loading={isSubmitting} variant='contained' form='IndividualForm' type="submit" color='primary'>
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
